<template>
	<div id="app">
		<router-view :key="key"> </router-view>
	</div>
</template>
<script>
export default {
	name: 'App',
	computed: {
		key() {
			return this.$route.name
				? this.$route.name + +new Date()
				: this.$route + +new Date();
		},
	},
};
</script>
<style lang="scss">
@import '~font-awesome/css/font-awesome.min.css';
@import 'style/animate.min.css';
.mr5 {
	margin-right: 5px;
}
.mr8 {
	margin-right: 8px;
}
.tiffany-font {
	color: #4db3b3;
}
//sass循环语法
@for $i from 0 through 100 {
	$px: $i * 1px !important; //默认间距单位

	.mb-#{$i} {
		margin-bottom: $px;
	}
	.ml-#{$i} {
		margin-left: $px;
	}
	.mr-#{$i} {
		margin-right: $px;
	}

	.mt-#{$i} {
		margin-top: $px;
	}
	.hg-#{$i} {
		height: $px;
		width: 100%;
	}
	.font-#{$i} {
		font-size: $px;
	}
}
</style>
